import {ConversationType} from '@toolify/server/src/models/mongoose/MessageModel/enum/ConversationType'
import {NotificationWrapperType} from '../types/NotificationWapperType'

export const GetMessageNotificationWrapperTypeByConversationTypeMap = new Map<ConversationType, NotificationWrapperType | null>([
  [ConversationType.Workspace, null],
  [ConversationType.CloudFile, null],
  [ConversationType.DatabaseCell, NotificationWrapperType.DatabaseItem],
  [ConversationType.DatabaseFile, NotificationWrapperType.DatabaseItem],
])
